import clsx from 'clsx';
import React from 'react';
import { Typography, TypographyType } from '../typography';
import { Icon } from '../icon';
import { TooltipComponent } from '../tooltip';

export type GenericBadgeColors = 'orange' | 'red' | 'green' | 'gray';

interface Props {
	label: string;
	typographyType?: TypographyType;
	colorStatus: GenericBadgeColors;
	classNameContainer?: string;
	icon?: string;
	showTooltip?: boolean;
}

export const GenericBadge: React.FC<Props> = ({
	label,
	colorStatus,
	classNameContainer,
	typographyType = 'semibold-14',
	icon,
	showTooltip = false,
}) => {
	return (
		<>
			<TooltipComponent
				className="w-[185px]"
				classNameLabel="!text-left"
				textType="regular-12"
				alignOffset={30}
				classNameArrow="-translate-x-5"
				trigger={
					<div
						className={clsx(
							'py-2 px-3 rounded-xl flex gap-1',
							{
								'!bg-[#40BB7126]': colorStatus === 'green',
								'bg-[#FD983433]': colorStatus === 'orange',
								'bg-[#FF004326]': colorStatus === 'red',
								'bg-grey-100': colorStatus === 'gray',
							},
							classNameContainer
						)}
					>
						{icon && (
							<Icon
								src={icon}
								width={16}
								height={16}
								className="text-primary"
							/>
						)}
						<Typography
							type={typographyType}
							className={clsx('text-[#0D0616] truncate capitalize', {
								'!text-green-120': colorStatus === 'green',
								'!text-main-orange': colorStatus === 'orange',
								'!text-[#FF0043]': colorStatus === 'red',
								'!text-opacity-black': colorStatus === 'gray',
							})}
						>
							{label}
						</Typography>
					</div>
				}
				label={showTooltip && label.length >= 19 ? label : ''}
			/>
		</>
	);
};
